/**
 * Labstep
 *
 * @module screens/Authentication/Signup/Left
 * @desc Signup Screen Left
 */

import { Divider } from 'labstep-web/core/Divider';
import { Icon } from 'labstep-web/core/Icon';
import { Benefits } from 'labstep-web/screens/Authentication/Shared';
import { Image } from 'semantic-ui-react';
import styles from './styles.module.scss';

export const SignupLeft = ({ bottomQuote }) => (
  <>
    <div className={styles.info}>
      <div className={styles.infoMessage}>
        A collaborative research environment with integrated ELN,
        inventory and order management modules. Built to simplify and
        accelerate scientific discovery.
      </div>
      <div>
        <Image src="/img/landing/robot_main.svg" />
      </div>
    </div>
    <div className={styles.container}>
      <Benefits header="Benefits of Labstep" />
      <Divider horizontal>
        <Icon color="teal" name="quote right" size="huge" />
      </Divider>
      <div className={styles.quote}>
        <p>{bottomQuote.quote}</p>
        <div>
          <b>{bottomQuote.name}</b>
          <p>{bottomQuote.affiliation}</p>
        </div>
      </div>
    </div>
  </>
);
